import { IAccount } from '../types';

/**
 * @param {Account[]} accounts
 * @param {Account} accountToFind
 */
export default function findAccountInAccounts(
  accounts: IAccount[],
  accountToFind?: IAccount | string
): IAccount | undefined {
  if (accountToFind) {
    let searchId;

    if (typeof accountToFind === 'string') {
      searchId = accountToFind;
    } else {
      searchId = accountToFind.subdomain
        ? accountToFind.subdomain
        : accountToFind.id;
    }

    for (const account of accounts) {
      if (account.subdomain === searchId) {
        return account;
      }
    }
  }

  return undefined;
}
